import React, { useEffect } from "react";
import { TransactionCard } from "../../../components/Cards/TransactionCard";
import { BottomNav } from "../../../components/Nav/BottomNav";
import { Wallet } from "../../../components/Wallet";
import { useDispatch, useSelector } from "react-redux";
import { getUserPaymentsRequest } from "../../../redux/action";
import { toast } from "react-toastify";
import { CircularProgress } from "@material-ui/core";

const Transaction = () => {
  const dispatch = useDispatch();

  const { user, getUserPaymentsError, payments, getUserPaymentsLoading } =
    useSelector((state) => {
      const {
        success: { claimInvestment: claimInvestmentSuccess },
        errors: {
          getUserPayments: getUserPaymentsError,
          claimInvestment: claimInvestmentError,
        },
      } = state.ajaxStatuses;

      const { getUserPaymentsLoading } = state.loadingIndicator;

      const { user } = state.userData;

      const { payments } = state.paymentData;

      return {
        user,
        getUserPaymentsError,
        payments,
        getUserPaymentsLoading,
      };
    });

  useEffect(() => {
    dispatch(getUserPaymentsRequest(user._id));
  }, [getUserPaymentsRequest]);

  useEffect(() => {
    if (getUserPaymentsError) {
      toast.error(getUserPaymentsError, {
        duration: 3000,
      });
    }
  }, [getUserPaymentsError]);

  return (
    <div>
      <div className="container px-4 py-8 max-w-sm mx-auto relative h-screen">
        <h2 className="font-body font-bold text-3xl">My Wallet</h2>
        <Wallet user={user} isHome={false} />

        <div className="my-6">
          <p className="font-body text-base">Transaction History</p>

          <div className="flex flex-col gap-y-1 mt-4">
            {getUserPaymentsLoading ? (
              <div className="h-[20vh] flex items-center justify-center text-center">
                <CircularProgress size={20} className="text-primary" />
              </div>
            ) : (
              <>
                {payments.map((payment, index) => (
                  <TransactionCard payment={payment} key={index} />
                ))}
              </>
            )}
          </div>
        </div>
      </div>

      <div className="py-8 max-w-sm mx-auto w-full ">
        <BottomNav />
      </div>
    </div>
  );
};

export default Transaction;
